export const stopWords = [
  "a",
  "able",
  "about",
  "above",
  "abst",
  "accordance",
  "according",
  "accordingly",
  "across",
  "act",
  "actually",
  "added",
  "adj",
  "affected",
  "affecting",
  "affects",
  "after",
  "afterwards",
  "again",
  "against",
  "ah",
  "all",
  "almost",
  "alone",
  "along",
  "already",
  "also",
  "although",
  "always",
  "am",
  "among",
  "amongst",
  "an",
  "and",
  "announce",
  "another",
  "any",
  "anybody",
  "anyhow",
  "anymore",
  "anyone",
  "anything",
  "anyway",
  "anyways",
  "anywhere",
  "apparently",
  "approximately",
  "are",
  "aren",
  "arent",
  "arise",
  "around",
  "as",
  "aside",
  "ask",
  "asking",
  "at",
  "auth",
  "available",
  "away",
  "awfully",
  "b",
  "back",
  "be",
  "became",
  "because",
  "become",
  "becomes",
  "becoming",
  "been",
  "before",
  "beforehand",
  "begin",
  "beginning",
  "beginnings",
  "begins",
  "behind",
  "being",
  "believe",
  "below",
  "beside",
  "besides",
  "between",
  "beyond",
  "biol",
  "both",
  "brief",
  "briefly",
  "but",
  "by",
  "c",
  "ca",
  "can",
  "cannot",
  "can't",
  "cause",
  "causes",
  "certain",
  "certainly",
  "co",
  "com",
  "come",
  "comes",
  "contain",
  "containing",
  "contains",
  "could",
  "couldnt",
  "d",
  "date",
  "did",
  "didn't",
  "different",
  "do",
  "does",
  "doesn't",
  "doing",
  "done",
  "don't",
  "down",
  "downwards",
  "due",
  "during",
  "e",
  "each",
  "ed",
  "edu",
  "effect",
  "eg",
  "eight",
  "eighty",
  "either",
  "else",
  "elsewhere",
  "end",
  "ending",
  "enough",
  "especially",
  "et",
  "et-al",
  "etc",
  "even",
  "ever",
  "every",
  "everybody",
  "everyone",
  "everything",
  "everywhere",
  "ex",
  "except",
  "f",
  "far",
  "few",
  "ff",
  "fifth",
  "first",
  "five",
  "fix",
  "followed",
  "following",
  "follows",
  "for",
  "former",
  "formerly",
  "forth",
  "found",
  "four",
  "from",
  "further",
  "furthermore",
  "g",
  "gave",
  "get",
  "gets",
  "getting",
  "give",
  "given",
  "gives",
  "giving",
  "go",
  "goes",
  "gone",
  "got",
  "gotten",
  "h",
  "had",
  "happens",
  "hardly",
  "has",
  "hasn't",
  "have",
  "haven't",
  "having",
  "he",
  "hed",
  "hence",
  "her",
  "here",
  "hereafter",
  "hereby",
  "herein",
  "heres",
  "hereupon",
  "hers",
  "herself",
  "hes",
  "hi",
  "hid",
  "him",
  "himself",
  "his",
  "hither",
  "home",
  "how",
  "howbeit",
  "however",
  "hundred",
  "i",
  "id",
  "ie",
  "if",
  "i'll",
  "im",
  "immediate",
  "immediately",
  "importance",
  "important",
  "in",
  "inc",
  "indeed",
  "index",
  "information",
  "instead",
  "into",
  "invention",
  "inward",
  "is",
  "isn't",
  "it",
  "itd",
  "it'll",
  "its",
  "itself",
  "i've",
  "j",
  "just",
  "k",
  "keep",
  "keeps",
  "kept",
  "kg",
  "km",
  "know",
  "known",
  "knows",
  "l",
  "largely",
  "last",
  "lately",
  "later",
  "latter",
  "latterly",
  "least",
  "less",
  "lest",
  "let",
  "lets",
  "like",
  "liked",
  "likely",
  "line",
  "little",
  "'ll",
  "look",
  "looking",
  "looks",
  "ltd",
  "m",
  "made",
  "mainly",
  "make",
  "makes",
  "many",
  "may",
  "maybe",
  "me",
  "mean",
  "means",
  "meantime",
  "meanwhile",
  "merely",
  "mg",
  "might",
  "million",
  "miss",
  "ml",
  "more",
  "moreover",
  "most",
  "mostly",
  "mr",
  "mrs",
  "much",
  "mug",
  "must",
  "my",
  "myself",
  "n",
  "na",
  "name",
  "namely",
  "nay",
  "nd",
  "near",
  "nearly",
  "necessarily",
  "necessary",
  "need",
  "needs",
  "neither",
  "never",
  "nevertheless",
  "new",
  "next",
  "nine",
  "ninety",
  "no",
  "nobody",
  "non",
  "none",
  "nonetheless",
  "noone",
  "nor",
  "normally",
  "nos",
  "not",
  "noted",
  "nothing",
  "now",
  "nowhere",
  "o",
  "obtain",
  "obtained",
  "obviously",
  "of",
  "off",
  "often",
  "oh",
  "ok",
  "okay",
  "old",
  "omitted",
  "on",
  "once",
  "one",
  "ones",
  "only",
  "onto",
  "or",
  "ord",
  "other",
  "others",
  "otherwise",
  "ought",
  "our",
  "ours",
  "ourselves",
  "outside",
  "over",
  "overall",
  "owing",
  "own",
  "p",
  "page",
  "pages",
  "part",
  "particular",
  "particularly",
  "past",
  "per",
  "perhaps",
  "placed",
  "please",
  "plus",
  "poorly",
  "possible",
  "possibly",
  "potentially",
  "pp",
  "predominantly",
  "present",
  "previously",
  "primarily",
  "probably",
  "promptly",
  "proud",
  "provides",
  "put",
  "q",
  "que",
  "quickly",
  "quite",
  "qv",
  "r",
  "ran",
  "rather",
  "rd",
  "re",
  "readily",
  "really",
  "recent",
  "recently",
  "ref",
  "refs",
  "regarding",
  "regardless",
  "regards",
  "related",
  "relatively",
  "research",
  "respectively",
  "resulted",
  "resulting",
  "results",
  "right",
  "run",
  "s",
  "said",
  "same",
  "saw",
  "say",
  "saying",
  "says",
  "sec",
  "section",
  "see",
  "seeing",
  "seem",
  "seemed",
  "seeming",
  "seems",
  "seen",
  "self",
  "selves",
  "sent",
  "seven",
  "several",
  "shall",
  "she",
  "shed",
  "she'll",
  "shes",
  "should",
  "shouldn't",
  "show",
  "showed",
  "shown",
  "showns",
  "shows",
  "significant",
  "significantly",
  "similar",
  "similarly",
  "since",
  "six",
  "slightly",
  "so",
  "some",
  "somebody",
  "somehow",
  "someone",
  "somethan",
  "something",
  "sometime",
  "sometimes",
  "somewhat",
  "somewhere",
  "soon",
  "sorry",
  "specifically",
  "specified",
  "specify",
  "specifying",
  "still",
  "stop",
  "strongly",
  "sub",
  "substantially",
  "successfully",
  "such",
  "sufficiently",
  "suggest",
  "sup",
  "sure",
  "t",
  "take",
  "taken",
  "taking",
  "tell",
  "tends",
  "th",
  "than",
  "thank",
  "thanks",
  "thanx",
  "that",
  "that'll",
  "thats",
  "that've",
  "the",
  "their",
  "theirs",
  "them",
  "themselves",
  "then",
  "thence",
  "there",
  "thereafter",
  "thereby",
  "thered",
  "therefore",
  "therein",
  "there'll",
  "thereof",
  "therere",
  "theres",
  "thereto",
  "thereupon",
  "there've",
  "these",
  "they",
  "theyd",
  "they'll",
  "theyre",
  "they've",
  "think",
  "this",
  "those",
  "thou",
  "though",
  "thoughh",
  "thousand",
  "throug",
  "through",
  "throughout",
  "thru",
  "thus",
  "til",
  "tip",
  "to",
  "together",
  "too",
  "took",
  "toward",
  "towards",
  "tried",
  "tries",
  "truly",
  "try",
  "trying",
  "ts",
  "twice",
  "two",
  "u",
  "un",
  "under",
  "unfortunately",
  "unless",
  "unlike",
  "unlikely",
  "until",
  "unto",
  "up",
  "upon",
  "ups",
  "us",
  "use",
  "used",
  "useful",
  "usefully",
  "usefulness",
  "uses",
  "using",
  "usually",
  "v",
  "value",
  "various",
  "'ve",
  "very",
  "via",
  "viz",
  "vol",
  "vols",
  "vs",
  "w",
  "want",
  "wants",
  "was",
  "wasnt",
  "way",
  "we",
  "wed",
  "welcome",
  "we'll",
  "went",
  "were",
  "werent",
  "we've",
  "what",
  "whatever",
  "what'll",
  "whats",
  "when",
  "whence",
  "whenever",
  "where",
  "whereafter",
  "whereas",
  "whereby",
  "wherein",
  "wheres",
  "whereupon",
  "wherever",
  "whether",
  "which",
  "while",
  "whim",
  "whither",
  "who",
  "whod",
  "whoever",
  "whole",
  "who'll",
  "whom",
  "whomever",
  "whos",
  "whose",
  "why",
  "widely",
  "willing",
  "wish",
  "with",
  "within",
  "without",
  "wont",
  "words",
  "world",
  "would",
  "wouldnt",
  "www",
  "x",
  "y",
  "yes",
  "yet",
  "you",
  "youd",
  "you'll",
  "your",
  "youre",
  "yours",
  "yourself",
  "yourselves",
  "you've",
  "z",
  "zero",
];

export const stopWordsSet = new Set(stopWords);
export const calcuation_types = new Set([
  "came",
  "cr",
  "conversion",
  "conversion rate",
  "wr",
  "winrate",
  "win rate",
  "lost",
  "lost-opportunities",
  "pipeline",
]);

export const value_types = new Set(["acv", "count", "opps"]);
export const metrics = [
  // "acv came to suspect",
  "bookings",
  "closed won acv",
  "closed won",
  // "win rate",
  // "win-rate",
  // "winrate",
  "won",
  // "acv",

  "opps",
];
export const months = {
  january: 1,
  february: 2,
  march: 3,
  april: 4,
  june: 6,
  july: 7,
  august: 8,
  september: 9,
  october: 10,
  november: 11,
  december: 12,
  jan: 1,
  feb: 2,
  mar: 3,
  apr: 4,
  may: 5,
  jun: 6,
  jul: 7,
  aug: 8,
  sep: 9,
  oct: 10,
  nov: 11,
  dec: 12,
};

export const extractedFilters = {
  type: "success",
  filters: {
    rep: {
      Full_Name: "Jake Coddington",
      UserID: "UID00001321",
      type: "rep",
    },
    cfq: ["2023-Q2"],
    metric: "closed won acv",
  },
  lkpStages: [
    {
      sequence: 2,
      stage_name: "Suspect",
      stage_name_db: "suspect",
      stage_type: "open",
      opp_status: "open",
      primary_stage_in_type: null,
      unqualified: "Y",
      index: 0,
    },
    {
      sequence: 3,
      stage_name: "Qualified",
      stage_name_db: "qualified",
      stage_type: "open",
      opp_status: "open",
      primary_stage_in_type: null,
      unqualified: null,
      index: 1,
    },
    {
      sequence: 4,
      stage_name: "Proposed",
      stage_name_db: "proposed",
      stage_type: "open",
      opp_status: "open",
      primary_stage_in_type: null,
      unqualified: null,
      index: 2,
    },
    {
      sequence: 5,
      stage_name: "Selected",
      stage_name_db: "selected",
      stage_type: "open",
      opp_status: "open",
      primary_stage_in_type: null,
      unqualified: null,
      index: 3,
    },
    {
      sequence: 6,
      stage_name: "Committed",
      stage_name_db: "committed",
      stage_type: "open",
      opp_status: "open",
      primary_stage_in_type: null,
      unqualified: null,
      index: 4,
    },
    {
      sequence: 7,
      stage_name: "Closed Won",
      stage_name_db: "closed_won",
      stage_type: "closed",
      opp_status: "won",
      primary_stage_in_type: "Y",
      unqualified: null,
      index: 5,
    },
  ],
};
export const dashboardDicts = {
  "Win Rate Trends": ["win", "trends", "win-rate"],
  "Lost Opportunities Analysis": [
    "opportunities",
    "lost-opportunities",
    "lost",
  ],
};
export const buildDict = () => {
  const kw_dict = {
    "Win Rate Trends": ["win", "trends", "win-rate"],
    "Lost Opportunities Analysis": [
      "opportunities",
      "lost-opportunities",
      "lost",
    ],
  };
  return kw_dict;
};
